import { CheckCircle2, Clock3, FileCheck2, ServerCog } from 'lucide-react';
import { useI18n } from '../i18n/useI18n';

export function ProofStatusCard() {
  const { t } = useI18n();

  return (
    <article className="proof-status-card" aria-label={t('proofCard.label')}>
      <div className="proof-card-header">
        <span className="status-dot" />
        <strong>{t('proofCard.status')}</strong>
      </div>
      <ul>
        <li>
          <CheckCircle2 size={18} />
          {t('proofCard.photo')}
        </li>
        <li>
          <Clock3 size={18} />
          {t('proofCard.time')}
        </li>
        <li>
          <FileCheck2 size={18} />
          {t('proofCard.package')}
        </li>
        <li>
          <ServerCog size={18} />
          {t('proofCard.server')}
        </li>
      </ul>
      <code>df31b81b2dc890eb757992fa94cbf1ba</code>
    </article>
  );
}
